import Layout from '@/layout';

export default {
  weight: 18,
  path: '/notification',
  component: Layout,
  redirect: '/notification/ruleList',
  name: 'notification',
  alwaysShow: true,
  meta: { title: '消息通知', icon: 'el-icon-message-solid' },
  children: [
    {
      path: 'ruleList',
      name: 'notificationRuleList',
      component: () => import('@/views/notification/notificationRuleList'),
      meta: { title: '通知规则', icon: 'el-icon-s-operation' },
    },
    {
      path: 'eventList',
      name: 'notificationEventList',
      component: () => import('@/views/notification/notificationEventList'),
      meta: { title: '通知事件', icon: 'el-icon-document' },
    },
    {
      path: 'deliveryList',
      name: 'notificationDeliveryList',
      component: () => import('@/views/notification/notificationDeliveryList'),
      meta: { title: '发送记录', icon: 'el-icon-s-promotion' },
    },
    {
      path: 'activityManagement',
      name: 'activityNotificationManagement',
      component: () => import('@/views/notification/activityNotificationManagement'),
      meta: { title: '活动通知管理', icon: 'el-icon-date', permission: 'activityNotificationManagement' },
    },
    {
      path: 'subscriptionCounts',
      name: 'subscriptionMessageCounts',
      component: () => import('@/views/notification/subscriptionMessageCounts'),
      meta: { title: '订阅消息次数', icon: 'el-icon-s-data', permission: 'activityNotificationManagement', permissionAliasOnly: true },
    },
    {
      path: 'activitySendRecords',
      name: 'activitySendRecords',
      component: () => import('@/views/notification/activitySendRecords'),
      meta: { title: '消息发送记录', icon: 'el-icon-document-checked', permission: 'activityNotificationManagement', permissionAliasOnly: true },
    },
  ],
};
